import * as React from 'react';

import { Location } from 'history';

import './ScrollToTop.scss';

interface ScrollToTopProps {
  location: Location;
}

export class ScrollToTop extends React.Component<ScrollToTopProps, {}> {
  componentDidUpdate(prevProps: ScrollToTopProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children as JSX.Element;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ScrollToTop/ScrollToTop.tsx